import Vue from 'vue'
import Router from 'vue-router'

import index from '@/components/index'
import success from '@/components/success'
import pdf from '@/components/pdf'
// 首页
import home from '@/components/home'
// 产品服务
import cpfu from '@/components/cpfu'

import gywm from '@/components/gywm'
import sxy from '@/components/sxy'
import hzal from '@/components/hzal'
import alxq from '@/components/alxq'
import cpgyl from '@/components/cpgyl'
import mk from '@/components/mk'
import mkxq from '@/components/mkxq'



import alxq1 from '@/components/alxq1'
import alxq2 from '@/components/alxq2'
import alxq3 from '@/components/alxq3'
import alxq4 from '@/components/alxq4'
import alxq5 from '@/components/alxq5'
// 
// 
// 
import alxq6 from '@/components/alxq6'
import alxq7 from '@/components/alxq7'
import alxq8 from '@/components/alxq8'
import alxq9 from '@/components/alxq9'
import alxq10 from '@/components/alxq10'
import alxq11 from '@/components/alxq11'
import alxq12 from '@/components/alxq12'
import alxq13 from '@/components/alxq13'
import alxq14 from '@/components/alxq14'
import alxq15 from '@/components/alxq15'
import alxq16 from '@/components/alxq16'


Vue.use(Router)
export default new Router({
  // mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'index', 
    //   component: index
    // },
    // {
    //   path: '/success',
    //   name: 'success',
    //   component: success
    // },
    // {
    //   path: '/pdf',
    //   name: 'pdf',
    //   component: pdf
    // },
// 

// {
//   path: '/',
//   name: 'home',
//   component: home,
//   meta: {
//     title: '首页title内容',
//     content:{
//       keywords:'这里是第一个keywords',
//       description:'这里是第一个description',
//     },
  
//   }
// },
{
  path: '/',  
  name: 'home', 
  component: home,
  meta: {
    title: '米创集团官网 - 米创科技',
    content:{
            keywords:'米商云,商e通,企业促销礼品,创新营销,B2B礼品采购平台,赠品营销,商家联盟,免费积分商城系统,私域流量营销,免费电商小程序,礼品采购平台',
            description:'米商云，作为中国新零售运营服务商致力为千百万实体商家营销添上互联网的翅膀，赋能新零售为实体商家提供丰富的营销管理工具，高效经营私域流浪，扩大营销受众，增加利润率，为全国商家提供1折爆品，微营销赋能。商E通，掌上实时掌握客户数据，多维度分析营销，让企业营销科学有方向。米小礼，新零售积分营销兑换平台，依托强大的供应链系统，海量品质好物一站免费兑换，帮助商家轻松搞定营销难题，让商家省钱，省力，省时，提升终端客户满意度，增加与客户之间的粘性。米小包，以互联云营销为依托平台，嫁接时下最热门的营销互动形式，海量营销工具包，助推企业快速实现裂变营销。',
          },
    requireAuth: true,
  }
},

    // {
    //   path: '/',
    //   name: 'home', 
    //   component: home,
    //   meta: {
    //     title: '教师培训-恩启官网',
    //     content: '教师培训、恩启培训、恩启云课堂、特教老师、线上服务、徐紫薇、王学钢'
    //   }
    //   // meta: {
    //   //   title: '米创集团官网|米商云|商E通|米小礼|米小包-致力全国的互联网新零售运营服务商！',
    //   //   requireAuth: true,
    //   //   meta:[
    //   //     { name: 'discription',content:'展览' },
    //   //     { name: 'keywords', content: '作品展,品牌展,广告设计展' }
    //   // ]
    //   // }
      
    // },
    {
      path: '/cpfu',  
      name: 'cpfu', 
      component: cpfu,
      meta: {
        title: '商e通官网 - 米创科技',
        title2: '米商云官网 - 米创科技',
        title3: '米小包 营销工具|营销互动海量营销工具包-米创科技',
        title4: '米小礼官网 - 米创科技',
        content:{
          keywords:'商e通,商业BI分析,多维数据分析,精准营销数据,客户分层数据,用户画像数据,1折爆品商城',
          description:'通过大数据分析消费人群的喜好方向水平与消费能力，并对搜集的数据进行实时分析，实现会员智能化管理，准确分析出会员的消费能力、消费水平、消费方向等实现会员精准营销，从而提高销售水平。严选品质好物，大牌尖货一折享，方案一键生成，高效助力营销落地，海量成熟案例积累，创新和重塑传统的零售商业模式，助推企业快速实现新零售转型',
        },
        requireAuth: true,
      }
    },
    {
      path: '/gywm',
      name: 'gywm', 
      component: gywm,
      meta: {
        title: '关于我们-米创科技',
        content:{
          keywords:'米创科技,米商云,米小礼,商e通,米小包,新零售服务商,新零售,营销策略,积分商城营销,赠品营销,实体店营销,礼品营销',
          description:'⽶创集团始终遵循以客户为中⼼，美好⽣活缔造者的核⼼理念，从起初专业家居家纺为主的单⼀型公司发展到如今“嘉佳纺⽣活”、“米创科技服务平台”两⼤业务版块双驱并⾏的综合型公司。公司持续将以互联⽹新零售模式为依托，不断致⼒于为客户提供完整的产品与服务体验，未来成长为平台资源整合商、新零售价值运营商及⾼品位⽣活⽅式的引领企业，最终搭建互联⽹+产业创新⽣态圈的商业格局。',
        },
        requireAuth: true,
      }
    },
    {
      path: '/sxy',
      name: 'sxy', 
      component: sxy,
      meta: {
        title: '商学院 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销。',
        },
        requireAuth: true,
      }

      
    },
    {
      path: '/hzal',
      name: 'hzal', 
      component: hzal,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
     {
      path: '/alxq',
      name: 'alxq', 
      component: alxq,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/cpgyl',
      name: 'cpgyl', 
      component: cpgyl,
      meta: {
        title: '供应链产品-米创科技',
        content:{
          keywords:'全品类产品供应链资源,新零售服务商,新零售,供应链合作,礼品供应商,电商营销,营销方案,营销策略,积分商城,到店引流,异业联盟,活动营销,营销案例',
          description:'产品供应链是米创科技专为广大新零售企业商家打造的全品类供应链资源，严选标准整合开发国内外知名品牌商3000多家，产品规划上架涵盖了，家居百货、家用电器、 美妆日化、精品箱包、鞋帽服饰、母婴文玩、生鲜食品、粮油副食、数码电子、户外运动、汽车用品等十多个大品类，5000+sku商品，实现会员自由选择兑换礼品提高商家会员满意度，营销爆品线:聚焦打造营销礼品的成本优势，助力商家降本提效。生活化运营为核心整合了本地化服务产品，休闲娱乐 美食打卡、美食探店、旅游住宿、家政服务、等吃喝玩乐的服务项目。实现了积分多维度应用让会员爱上积分，帮助商家提高会员粘性。',
        },
        requireAuth: true,
      }
    },
    {
      path: '/mk',
      name: 'mk', 
      component: mk,
      meta: {
        title: '米咖视频-米创科技',
        content:{
          keywords:'新零售服务商,新零售,供应链合作,礼品供应商,电商营销,营销方案,营销策略,积分商城,到店引流,异业联盟,活动营销,营销案例',
          description:'米咖视频是米创科技专为广大新零售企业商家打造的服务内容IP，对积分兑换平台、互联网技术应用 、新零售运营支持、会员售后服务管理”等核心内容进行的内容包装。专业为实体商家新零售运营服务，实现流量获客资源、客户维护管理、业绩持续增长、品牌价值提升，提供全方位智慧营销解决方案，努力为商家和行业创造价值。',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq1',
      name: 'alxq1', 
      component: alxq1,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq2',
      name: 'alxq2', 
      component: alxq2,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq3',
      name: 'alxq3', 
      component: alxq3,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq4',
      name: 'alxq4', 
      component: alxq4,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq5',
      name: 'alxq5', 
      component: alxq5,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    // 
    // 
    // 
    // 
    {
      path: '/alxq6',
      name: 'alxq6', 
      component: alxq6,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq7',
      name: 'alxq7', 
      component: alxq7,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq8',
      name: 'alxq8', 
      component: alxq8,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq9',
      name: 'alxq9', 
      component: alxq9,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq10',
      name: 'alxq10', 
      component: alxq10,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq11',
      name: 'alxq11', 
      component: alxq11,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq12',
      name: 'alxq12', 
      component: alxq12,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq13',
      name: 'alxq13', 
      component: alxq13,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq14',
      name: 'alxq14', 
      component: alxq14,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq15',
      name: 'alxq15', 
      component: alxq15,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },
    {
      path: '/alxq16',
      name: 'alxq16', 
      component: alxq16,
      meta: {
        title: '合作案例 营销案例|商业教学-米创科技',
        content:{
          keywords:'营销案例,营销策略,赠品营销,实体店营销',
          description:'礼品采购平台案例库、实体企业营销案例库，积分商城案例分享，赠品营销案例分享,店铺周年庆活动运营策划案例，集合餐饮食品、车行、房地产、服装、建材装修家居、教育培训等行业营销',
        },
        requireAuth: true,
      }
    },

  ]
  
})



// WEBPACK FOOTER //
// ./src/router/index.js